module.exports = __webpack_public_path__ + "img/clock.41de885d.svg";